import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faArrowsRotate, faCalendarDays, faSliders, faUsers } from '@fortawesome/free-solid-svg-icons';
import { TranslationKeys } from 'app/translations';
import type { FileUploadCleanupPreviewResponse } from '../../Services';

// ─── Colour palette ───────────────────────────────────────────────────────────

export const COLOR_FILE = '#00A0FF';
export const COLOR_EMPLOYEE = '#40C484';
export const COLOR_PAYROLL = '#F3AE43';
export const COLOR_EVENTS = '#7C4DFF';
export const COLOR_ADJUSTMENTS = '#DF7070';

// ─── Types ────────────────────────────────────────────────────────────────────

export type CountItem = { labelId: string; count: number };

export type PreviewGroup = {
  titleId: string;
  color: string;
  icon: IconDefinition;
  items: CountItem[];
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

export const buildPreviewGroups = (data: FileUploadCleanupPreviewResponse): PreviewGroup[] => [
  {
    titleId: TranslationKeys.adminPanel_undoUploadedFile_preview_section_employeeData,
    color: COLOR_EMPLOYEE,
    icon: faUsers,
    items: [
      { labelId: TranslationKeys.adminPanel_undoUploadedFile_preview_employees, count: data.employees },
      { labelId: TranslationKeys.adminPanel_undoUploadedFile_preview_employments, count: data.employments },
      { labelId: TranslationKeys.adminPanel_undoUploadedFile_preview_addresses, count: data.addresses },
    ],
  },
  {
    titleId: TranslationKeys.adminPanel_undoUploadedFile_preview_section_payrollData,
    color: COLOR_PAYROLL,
    icon: faCalendarDays,
    items: [
      { labelId: TranslationKeys.adminPanel_undoUploadedFile_preview_runs, count: data.runs },
      {
        labelId: TranslationKeys.adminPanel_undoUploadedFile_preview_employeeComponentValues,
        count: data.employeeComponentValues,
      },
      { labelId: TranslationKeys.adminPanel_undoUploadedFile_preview_wages, count: data.wages },
      { labelId: TranslationKeys.adminPanel_undoUploadedFile_preview_schedules, count: data.schedules },
    ],
  },
  {
    titleId: TranslationKeys.adminPanel_undoUploadedFile_preview_section_eventsSync,
    color: COLOR_EVENTS,
    icon: faArrowsRotate,
    items: [
      { labelId: TranslationKeys.adminPanel_undoUploadedFile_preview_events, count: data.events },
      {
        labelId: TranslationKeys.adminPanel_undoUploadedFile_preview_synchronizations,
        count: data.synchronizations,
      },
    ],
  },
  {
    titleId: TranslationKeys.adminPanel_undoUploadedFile_preview_section_adjustments,
    color: COLOR_ADJUSTMENTS,
    icon: faSliders,
    items: [
      {
        labelId: TranslationKeys.adminPanel_undoUploadedFile_preview_employeesWithSourceItemsToReset,
        count: data.employeesWithSourceItemsToReset,
      },
    ],
  },
];

export const noFilesFoundForDate = (data: FileUploadCleanupPreviewResponse): boolean => data.uploadedFiles === 0;

export const totalRecords = (data: FileUploadCleanupPreviewResponse): number =>
  data.uploadedFiles +
  data.employees +
  data.employments +
  data.addresses +
  data.runs +
  data.employeeComponentValues +
  data.wages +
  data.schedules +
  data.events +
  data.synchronizations;
